import React from 'react';
import PropTypes from 'prop-types';
import { iconGray } from '../../theme';

const Profile = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28 32">
    <path
      d="M19.6-9C17.806-9,16.944-8,14-8S10.2-9,8.4-9A8.4,8.4,0,0,0,0-.6V1A3,3,0,0,0,3,4H25a3,3,0,0,0,3-3V-.6A8.4,8.4,0,0,0,19.6-9ZM25,1H3V-.6A5.409,5.409,0,0,1,8.4-6c.912,0,2.394,1,5.6,1,3.231,0,4.681-1,5.6-1A5.409,5.409,0,0,1,25-.6ZM14-10a9,9,0,0,0,9-9,9,9,0,0,0-9-9,9,9,0,0,0-9,9A9,9,0,0,0,14-10Zm0-15a6.01,6.01,0,0,1,6,6,6.01,6.01,0,0,1-6,6,6.01,6.01,0,0,1-6-6A6.01,6.01,0,0,1,14-25Z"
      transform="translate(0 28)"
      fill={color}
    />
  </svg>
);

Profile.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Profile.defaultProps = {
  width: 28,
  height: 32,
  color: iconGray,
};

export default Profile;
